const SUPABASE_PUBLIC_STORAGE_BUCKET_NAME = "public-assets";
const PublicStorageFolder = {
  LOGOS: "logos",
  FAVICONS: "favicons"
};
const getLogoUrl = (appUrl, logoFileName) => {
  return `${appUrl}/storage/v1/object/public/${SUPABASE_PUBLIC_STORAGE_BUCKET_NAME}/${PublicStorageFolder.LOGOS}/${logoFileName}`;
};
const getFaviconUrl = (appUrl, faviconFileName) => {
  return `${appUrl}/storage/v1/object/public/${SUPABASE_PUBLIC_STORAGE_BUCKET_NAME}/${PublicStorageFolder.FAVICONS}/${faviconFileName}`;
};
export {
  PublicStorageFolder,
  SUPABASE_PUBLIC_STORAGE_BUCKET_NAME,
  getFaviconUrl,
  getLogoUrl
};
//# sourceMappingURL=publicStorage.js.map
